import DatePicker, { DatePickerProps } from 'antd/es/date-picker'
import dayjs from 'dayjs'

type IdeyaDatePickerProps = Omit<DatePickerProps, 'value' | 'onChange'> & {
  value?: string
  onChange?: (value?: string) => void
}

export const IdeyaDatePicker: React.FC<IdeyaDatePickerProps> = ({
  value,
  onChange,
  ...rest
}) => {
  return (
    <DatePicker
      {...rest}
      allowClear={false}
      value={value ? dayjs(value, 'YYYY-MM-DD') : null}
      onChange={(date) =>
        onChange?.(date ? date.format('YYYY-MM-DD') : undefined)
      }
    />
  )
}
